<template>
  <div class="edit">
    <Form ref="paasForm" slot="form"
          :label-width="defaultLabelWidth">
      <Row>
        <div v-for="item in paasData" :key="item.id">
          <m-divider orientation="left">{{item.orderProduct.name}} </m-divider>
          <FormItem label="定单号："  class="ivu-col-span-24" >
          <span>{{item.orderCode}}</span>
        </FormItem>
        <FormItem label="快递名称："  class="ivu-col-span-24" >
            <span>{{item.expressName}}</span>
        </FormItem>
        <FormItem label="快递单号："  class="ivu-col-span-24" >
            <span>{{item.expressCode}}</span>
        </FormItem>
        <FormItem label="快递详情："  class="ivu-col-span-24" >
          <div v-for="(ex,index) in item.trackDto.data" :key="index">
            <div>{{ex.time}} {{ex.status}}</div>
          </div>
        </FormItem>
        </div>
      </Row>
    </Form>
  </div>
</template>

<script>
 import metaList from "@assets/js/list/meta-list.js";
 import mDivider from '@components/divider/m-divider'
export default {
  name: "expressRecord",
  mixins: [ metaList ],
  props: {
    paasData: {
        type: Array,
        default: () => []
      }
    },
  components:{mDivider},
  data() {
    return {
      serviceUrl: "/eb/order/send",
      currentIdFiledName: 'id',
      defaultLabelWidth: 120,
    }
  },


}
</script>

<style>

</style>